import styles from './descriptionLoadingSkeleton.module.scss';

const descriptionBlocks = [5, 12, 12];

const DescriptionLoadingSkeleton = () => {
  return (
    <div
      className={styles.container}
      data-testid='description-loading-skeleton'
      aria-busy='true'
      aria-label='Loading project description'
    >
      <section className={styles.descriptionSection} aria-label='Loading descriptions'>
        {descriptionBlocks.map((lineCount, index) => (
          <div
            className={styles.descriptionBlock}
            data-testid='description-text-skeleton'
            key={`description-block-${index}`}
          >
            <span className={styles.heading} />
            <div className={styles.descriptionContent}>
              <div className={styles.languageBar}>
                {Array.from({ length: 4 }, (_, languageIndex) => (
                  <span className={styles.languagePlaceholder} key={`language-${index}-${languageIndex}`} />
                ))}
              </div>
              <div className={styles.textArea}>
                {Array.from({ length: lineCount }, (_, lineIndex) => (
                  <span
                    className={styles.textLine}
                    key={`text-line-${index}-${lineIndex}`}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className={styles.gallerySection} aria-label='Loading photo gallery'>
        <span className={styles.sectionHeading} />
        <div className={styles.galleryPlaceholder}>
          <span className={styles.galleryImage} />
          <div className={styles.galleryControls}>
            <span className={styles.controlPlaceholder} />
            <span className={styles.controlPlaceholder} />
          </div>
        </div>
      </section>

      <section className={styles.documentationSection} aria-label='Loading documentation'>
        <span className={styles.sectionHeading} />
        <div className={styles.documentationList}>
          {Array.from({ length: 3 }, (_, index) => (
            <div
              className={styles.documentationItem}
              data-testid='description-documentation-skeleton'
              key={`documentation-${index}`}
            >
              <span className={styles.documentIcon} />
              <div className={styles.documentText}>
                <span className={styles.documentTitle} />
                <span className={styles.documentSubtitle} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default DescriptionLoadingSkeleton;
